import {AFD} from 'devegram-javascript-util'
import {bootModules} from "@/app/booting/boot";

const baseUrl = '/xapi/User/Mrt';
const moduleAjaxService = 'backend-service'
const api = {
    namespaced: true,
    state: {
        dropDownList: []
    },
    actions: {
        async completeMrtRegistration(context, params) {
            return new Promise((resolve, reject) => {
                $store.dispatch('ajaxManager/api', {
                    service: 'AMS',
                    verb: 'post',
                    url: '/xapi/Individual/User/mrtSuccessfulPayment',
                    data: AFD(params.data),
                    noToken: true
                }).then(r => {
                    resolve(r.data)
                }).catch(e => {
                    reject(e);
                });
            });
        },
        async registerNewMRTUser(context, params) {
            return new Promise((resolve, reject) => {
                $store.dispatch('ajaxManager/api', {
                    service: moduleAjaxService,
                    verb: 'post',
                    url: baseUrl + '/registerMRTUser',
                    data: AFD(params.data),
                    noToken: true
                }).then(r => {
                    resolve(r)
                }).catch(e => {
                    reject(e);
                });
            });
        },
        async create(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/store',
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    Vue.set(context.state.dropDownList, {value: r.id, label: r.label})
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async update(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/update/' + params.id,
                data: AFD(params.data),
                noLoadingScreen: true
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async remove(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/remove/' + params.id
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async get(context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/get/' + params.id
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async list(context, params) {
            let page = (params.page) ? params.page : 1
            let search = (params.hasOwnProperty('search')) ? "&search=" + encodeURIComponent(params.search) : ''
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/list?page=' + page + search,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getDropDownList(context, params = {}) {
            if (context.state.dropDownList.length) {
                return new Promise((resolve, reject) => {
                    return context.state.dropDownList
                })
            }

            let query = ''
            if (params.hasOwnProperty('valueKey')) {
                query = '?value_key=' + params.valueKey
            }
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/dropDownList' + query,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    context.state.dropDownList = r.data
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        }
    }

};

export default api
